import { render, staticRenderFns } from "./newService.vue?vue&type=template&id=5e5327c4"
import script from "./newService.vue?vue&type=script&lang=js"
export * from "./newService.vue?vue&type=script&lang=js"
import style0 from "./newService.vue?vue&type=style&index=0&id=5e5327c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports